import { ChangeDetectionStrategy, Component, booleanAttribute, input, output } from '@angular/core';
import {
  HdCycleGateKeynoteLineComponent,
  HdCycleGateLineInfoRequest,
} from '../channel-list/hd-cycle-gate-keynote-line.component';
import { HdCycleHangingGateVm } from '../hd-cycle-keynotes.builder';
import { HdCycleCardsToggleComponent } from './hd-cycle-cards-toggle.component';

/**
 * Omgevend-blokje: een hangende cycle-/transitpoort in hetzelfde blokje-patroon
 * als de kanaal-items (lichte border + linkerborder in de keynote-kleur +
 * icoon), zonder kanaaltekst — enkel de poort-chip met keynotes.
 *
 * Gedeeld door `hd-cycle-keynote-sections` en het Just Now-paneel.
 */
@Component({
  selector: 'hd-cycle-hanging-gate-block',
  templateUrl: './hd-cycle-hanging-gate-block.component.html',
  styleUrl: './hd-cycle-hanging-gate-block.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [HdCycleGateKeynoteLineComponent, HdCycleCardsToggleComponent],
})
export class HdCycleHangingGateBlockComponent {
  readonly hanging = input.required<HdCycleHangingGateVm>();
  /** Keynote-kleur (linkerborder + icoon). */
  readonly color = input.required<string>();
  /** Bare FA-icoonnaam van de keynote; leeg = geen icoon. */
  readonly faIcon = input('');
  /** Uitklapknop rechts; de ouder rendert de I Tjing-kaarten eronder en bezit de staat. */
  readonly expandable = input(false, { transform: booleanAttribute });
  readonly expanded = input(false);
  readonly expandToggled = output<void>();

  readonly gateInfoRequested = output<HdCycleGateLineInfoRequest>();
}
